import { FC, PropsWithChildren, useEffect } from 'react';
import { useFetchAllData } from 'src/redesign/shared/hooks/useFetchAllData';
import { useAppDispatch, useAppSelector } from 'src/hooks';
import { fetchWhiteLabelConfig } from 'src/redesign/features/WhiteLabel/store/actions';
import { whiteLabelConfigSelector } from 'src/redesign/features/WhiteLabel/store/selectors';
import {
  updateCSSVariables,
  updateFavicon,
  updatePageTitle,
} from 'src/redesign/features/WhiteLabel/utils/updateCSSVariables';

export const Bootstrap: FC<PropsWithChildren<unknown>> = ({ children }) => {
  const dispatch = useAppDispatch();
  const whiteLabelConfig = useAppSelector(whiteLabelConfigSelector);

  useFetchAllData();

  // Fetch white label config on mount (runs for all routes including login/signup)
  useEffect(() => {
    void dispatch(fetchWhiteLabelConfig());
  }, [dispatch]);

  // Apply white label styling when config is loaded
  useEffect(() => {
    if (whiteLabelConfig) {
      updateCSSVariables(whiteLabelConfig);
      updateFavicon(whiteLabelConfig.logo_url);
      updatePageTitle(whiteLabelConfig.site_name);
    }
  }, [whiteLabelConfig]);

  return <>{children}</>;
};
